import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class AuthService {
  private userSubject = new ReplaySubject<any>(1); // buffer size 1
  private userLoaded = false;

  constructor(private http: HttpClient, private router: Router) {}

  login(username, password): Observable<any> {

    const data = 'j_username=' + encodeURIComponent(username) + '&j_password=' + encodeURIComponent(password) + '&submit=Login';
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post('api/authentication', data, {
      headers,
    });
  }
  logout(): Observable<any> {
    // logout from the server
    return this.http.post('api/logout', {}).pipe(map((response: Response) => {
      localStorage.removeItem("auth_token");
       // Clear local and session storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear service worker cache if applicable
    if ('caches' in window) {
      caches.keys().then(names => {
        for (let name of names) caches.delete(name);
      });
    }
      return response;
    }));
  }

  logSessionActivity(event, username) {
    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    return this.http.post(
      'api/logsessionactivity?eventname=' + event + '&login=' + username,
      { headers: headers }
    );
  }


  addCustomerAdmin(data)
  {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }
    return this.http.post(   'api/company/addadmin', JSON.stringify(data),  httpOptions


     )
  }

  addCompany(data)
  {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }
    return this.http.post(   'api/company/new',   JSON.stringify(data),   httpOptions    )
  }

  loadUser(): Observable<any> {
    if (!this.userLoaded) {
      this.http.get('/api/me').subscribe({
        next: (user: any) => {
          this.userLoaded = true;
          this.userSubject.next(user);
        },
        error: (err) => {
          console.error('Failed to load user', err);
          this.userSubject.next(null);
        },
      });
    }
    return this.userSubject.asObservable();
  }

  getUser(): Observable<any> {
    return this.userSubject.asObservable();
  }
  
fetchXCSRFToken(){
    this.http.get('api/account').subscribe(
      () => {},
      () => {}
    );

  }

}
